import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import styles from './Navigation.module.css'


const navigationItems = [
  //{ id: 'dashboard', label: '대시보드', path: '/dashboard' },
  { id: 'drawing', label: '드로잉', path: '/drawing' },
  { id: 'community', label: '갤러리', path: '/community' },
  { id: 'diary', label: '다이어리', path: '/diary' }
]

const Navigation = () => {
  const navigate = useNavigate()
  const location = useLocation()


  const handleItemClick = (path) => {
    navigate(path)
  }

  return (
    <nav className={styles.navigation}>
      <ul className={styles.navList}>
        {navigationItems.map((item) => (
          <li key={item.id} className={styles.navItem}>
            <button
              className={`${styles.navButton} ${
                (location.pathname === item.path || location.pathname.startsWith(item.path)) ? styles.active : ''
              }`}
              onClick={() => handleItemClick(item.path)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default Navigation